// ── Préférences de traduction ─────────────────────────────────────────────────

const LS_PREFS_TRADUCTIONS = 'usito.prefs.traductions';

/** Regex de validation d'une clé de paire de langues (ex. "en-fr). */
const PAIRE_REGEX = /^[a-z]+-[a-z]+$/;

/**
 * Lit les préférences de traduction depuis localStorage.
 * Retourne un objet dont les clés sont des paires "xx-yy" et les valeurs des booléens.
 * Aucune liste de langues codées en dur : les paires connues sont celles stockées.
 * @returns {Object}
 */
export function lirePrefsTraductions() {
    const valeur = localStorage.getItem(LS_PREFS_TRADUCTIONS);
    if (!valeur) return {};
    try {
        const brut = JSON.parse(valeur);
        const prefs = {};
        for (const [clé, val] of Object.entries(brut)) {
            if (PAIRE_REGEX.test(clé)) prefs[clé] = val === true;
        }
        return prefs;
    } catch (e) {
        return {};
    }
}

/**
 * Indique si une paire de traduction est activée dans les préférences.
 * @param {string} clé  ex. "en-fr"
 * @returns {boolean}
 */
export function estPrefActive(clé) {
    return lirePrefsTraductions()[clé] === true;
}

/**
 * Sauvegarde les préférences de traduction dans localStorage.
 * @param {Object} prefs  objet {"xx-yy": bool, ...}
 */
export function sauvegarderPrefsTraductions(prefs) {
    localStorage.setItem(LS_PREFS_TRADUCTIONS, JSON.stringify(prefs));
}
